export default __webpack_public_path__ + "34150ab28d962972326c8cd5b422faf1.svg";